export const ApplicationPostingRoute = {
  path: '/Application/Posting',
  load: () => import('./ApplicationPosting'),
  hideLayout: true,
};
